export const accountMenu = {
  roles: {
    collaborator: "Collaborator",
    hostMode: "Host mode",
  },
  header: {
    collaboratorAccess: "Collaborator access",
  },
  panel: {
    label: "Panel view",
    apartment: "Apartment",
    hotel: "Hotel",
  },
  groups: {
    navigate: "Navigate",
    manage: "Manage",
  },
  items: {
    home: "Home",
    bookings: "Bookings",
    myAccount: "My account",
    myAccommodations: "My accommodations",
    aiReception: "AI reception",
    aiReceptionist: "AI receptionist",
    directBookings: "Direct bookings",
    website: "Website",
    logout: "Log out",
  },
  badges: {
    ai: "AI",
    new: "NEW",
  },
  actions: {
    close: "Close",
  },
};
